import React, { useEffect } from "react";
import HeaderNew from "../Component/HeaderNew";
import Banner from "../Component/Depin/Banner";
import HowItWorks from "../Component/Depin/HowItWorks";
import SmartStorage from "../Component/Depin/SmartStorage";
import DistributedDelivery from "../Component/Depin/DistributedDelivery";
import Transcoding from "../Component/Depin/Transcoding";
import DepinMap from "../Component/Depin/DepinMaps";
import AppDemo from "../Component/Depin/AppDemo";
import FooterNew from "../Component/FooterNew";

function Depin() {
  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     left: 0,
  //     behavior: "smooth",
  //   });
  // }, []);
  return (
    <div className="depin">
      <HeaderNew />
      <div className="container ai-container">
        {/* <div className="depin_banner">
          <div className="heading_sec">
            <h1 className="title-txt text-center">
              Make Your Computer Work For You
            </h1>
            <h6 className="des-txt text-center">
              With an internet connection, you can power <br />
              the AInfra Network and be Rewarded in AIF Tokens.
            </h6>
          </div>
          <div className="bnr_sec">
            <img src={Images.depinBannerBg} className="bg_src img-fluid" />
            <img src={Images.depinBannerGif} className="gif_src img-fluid" />
            <div className="tdl_cnt">
              <div className="count_sec">
                <div className="items">
                  <div>
                    <p className="title-txt fw-500">Total Depin</p>
                    <h4 className="value-txt fw-700">261,207</h4>
                  </div>
                </div>
                <div className="items">
                  <div>
                    <p className="title-txt fw-500">Data File Batches</p>
                    <h4 className="value-txt fw-700">21,514,559</h4>
                  </div>
                </div>
                <div className="items">
                  <div>
                    <p className="title-txt fw-500">Data Delivery</p>
                    <h4 className="value-txt fw-700">13,208.904 TB</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <Banner />
        <HowItWorks />
        <SmartStorage />
        <DistributedDelivery />
        <Transcoding />
        <DepinMap />
        <AppDemo />
      </div>
      <FooterNew />
    </div>
  );
}

export default Depin;
